function ChartLabels({ children, extraStyle = undefined }) {
    return (
        <div className={"w-full flex flex-row space-x-[10px] px-[20px] border-b-[1px] border-gray-10 box-border " + ((extraStyle !== undefined) ? extraStyle : "")}>
            {children}
        </div>
    )
}

export default ChartLabels
